import { getWujiFetchAccess, doubleCheckLoginStatusAndDisplayLoginIfNeeded } from './getAccess';
import axios from 'axios';
import { getRuntimeEnvPath } from '@/config/constant';
import { getAppParams } from '@/utils/getAppParams';
import { addPathPrefix } from '@/utils/path';
import getXyHeaders from '@/utils/getXyHeaders';
function getAIScfProxyUrl(path) {
    const { env, projectId, branch } = getAppParams();
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const currentProjectId = projectId || window.w?.projectId || '';
    const proxyUrl = `${getRuntimeEnvPath(env || 'dev', branch)}/ai-scf/${encodeURIComponent(currentProjectId)}/access${normalizedPath}`;
    return /^(https?:)?\/\//.test(proxyUrl) ? proxyUrl : addPathPrefix(proxyUrl);
}
function isLocalDevBaseUrl(baseUrl) {
    try {
        const { hostname } = new URL(baseUrl);
        return hostname === '127.0.0.1' || hostname === 'localhost';
    }
    catch {
        return false;
    }
}
/** dev 本地 scf 地址在浏览器不可达时走 server 代理 */
function shouldUseRuntimeProxy(access) {
    if (access.deployId)
        return false;
    return isLocalDevBaseUrl(access.baseUrl);
}
export async function wujiAxiosAIScf(path, config) {
    const access = await getWujiFetchAccess({ method: config.method || 'GET' });
    if (!access)
        throw new Error('Failed to get wujiFetch access');
    const useRuntimeProxy = shouldUseRuntimeProxy(access);
    const actualUrl = useRuntimeProxy ? getAIScfProxyUrl(path) : `${access.baseUrl}${path}`;
    const actualConfig = {
        ...config,
        url: actualUrl,
        params: { ...config.query, ...config.params },
        headers: {
            ...config.headers,
            ...(useRuntimeProxy
                ? { ...getXyHeaders(), 'X-Requested-With': 'XMLHttpRequest' }
                : { Authorization: `Bearer ${access.token}`, 'X-Requested-With': 'XMLHttpRequest' }),
        },
        ...(useRuntimeProxy ? { withCredentials: true } : {}),
    };
    try {
        const res = await axios.request(actualConfig);
        return res;
    }
    catch (error) {
        if (error.response) {
            if (error.response.status === 401 && !error.response.headers['X-Powered-By']?.startsWith('Wuji-Gogo-Scf-Proxy')) {
                doubleCheckLoginStatusAndDisplayLoginIfNeeded();
            }
        }
        throw error;
    }
}
export async function wujiFetchAIScf(path, options) {
    const access = await getWujiFetchAccess({ method: options?.method || 'GET' });
    if (!access)
        throw new Error('Failed to get wujiFetch access');
    const useRuntimeProxy = shouldUseRuntimeProxy(access);
    const headers = new Headers(options?.headers || {});
    if (useRuntimeProxy) {
        Object.entries(getXyHeaders()).forEach(([key, value]) => headers.set(key, value));
        headers.set('X-Requested-With', 'XMLHttpRequest');
    }
    else {
        headers.set('Authorization', `Bearer ${access.token}`);
        headers.set('X-Requested-With', 'XMLHttpRequest');
        if (access.deployId) {
            headers.set('X-Deploy-Id', access.deployId);
        }
    }
    const actualUrl = useRuntimeProxy ? getAIScfProxyUrl(path) : `${access.baseUrl}${path}`;
    const actualOptions = {
        ...options,
        credentials: 'include',
        headers,
    };
    const res = await fetch(actualUrl, actualOptions);
    if (!res.ok) {
        if (res.status === 401 && !res.headers.get('X-Powered-By')?.startsWith('Wuji-Gogo-Scf-Proxy')) {
            doubleCheckLoginStatusAndDisplayLoginIfNeeded();
            // TODO: 需不需要重发请求？好像会有问题，先算了
            // const resp = await doubleCheckLoginStatusAndDisplayLoginIfNeeded();
            // if (resp === 'sso-login-done') return await fetch(actualUrl, actualOptions);
        }
    }
    return res;
}
